import React from 'react'
import CsplLabel from '../../../CsplControls/CsplLabel/CsplLabel';
import styles from '../Preview.module.css';
import { Accordion } from 'react-bootstrap';
import "../../../CsplControls/CsplAccordion/CsplAccordion.css";

function BankAccVerificationView(props) {
    return (
        <>
 <Accordion className='parentaccordion_style'>
         {/* Bank Acoount verify */}
      <div>
            <Accordion.Item eventKey="0" className=''>
            {props && props.data && props.data.bankAccountVerificationDTO && 
            <>
          <Accordion.Header> 
               <span className="w-100"><CsplLabel label={"bankdetails.bankAccountVerification"}></CsplLabel></span>
               </Accordion.Header> 
               <Accordion.Body>
                <div className='dotted_line'>
                    <div className={styles.table_content}>
                    <table className="table table-striped table-bordered border-white table-responsive">
                        <tbody className={styles.table_alternate_color}>
                            <tr >
                                <th className={styles.table_header}><CsplLabel label={"bankdetails.bankname"}></CsplLabel></th>
                                <td>{props.data.bankAccountVerificationDTO.bankAccountDetailsDTO.bankName.name}</td>
                            </tr>
                            <tr >
                                <th className={styles.table_header}><CsplLabel label={"bankdetails.branchname"}></CsplLabel></th>
                                <td>{props.data.bankAccountVerificationDTO.bankAccountDetailsDTO.branch}</td>
                            </tr>

                            <tr >
                                <th className={styles.table_header}><CsplLabel label={"bankdetails.accountHolderName"}></CsplLabel></th>
                                <td>{props.data.bankAccountVerificationDTO.bankAccountDetailsDTO.name}</td>
                            </tr>
                            <tr >
                                <th className={styles.table_header}><CsplLabel label={"bankdetails.ifsc"}></CsplLabel></th>
                                <td>{props.data.bankAccountVerificationDTO.bankAccountDetailsDTO.ifscCode}</td>
                            </tr>
                            <tr >
                                <th className={styles.table_header}><CsplLabel label={"bankdetails.accountnumber"}></CsplLabel></th>
                                <td>{props.data.bankAccountVerificationDTO.bankAccountDetailsDTO.accountNumber}</td>
                            </tr>
                            <tr >
                                <th className={styles.table_header}><CsplLabel label={"bankdetails.accounttype"}></CsplLabel></th>
                                <td>{props.data.bankAccountVerificationDTO.bankAccountDetailsDTO.accountType.name}</td>
                            </tr>

                        </tbody>
                    </table>
                       </div>
                </div>
                </Accordion.Body>
                </>

            }
             </Accordion.Item>
             </div>
 </Accordion>

        </>
    )
}

export default BankAccVerificationView;